/* eslint-disable no-await-in-loop */
import { reverse, sortBy } from 'lodash';

import actions from '../../constants/actionTypes';
import request from '../../utils/request';

import { setGeneralError } from '../../layout/components/UniversalModal/actions';
import { trans } from '../../localization';
import {
  formatDateTime,
  isEmptyObject,
  isSuccess,
  parseDateTime,
  sendNotify,
  wait,
} from '../../utils/utils';

import {
  CHAT_MESSAGE_MAX_LENGTH,
  COMMON_CONST,
  MAX_RETRY_ATTEMPT,
  SLEEP_TIMEOUT,
} from '../../constants/constants';
import {
  EnumChatAppType,
  EnumChatTabTypeNowShip,
  EnumMqttChatPayloadTypeNowShip,
  EnumUserChatRole,
  findEnumById,
} from '../../constants/enum';
import {
  parseMessageListNowShip,
  parseMessageNowShip,
  parseUserSeenStatusListNowShip,
} from './parser';
import { getMetadataNowShip } from '../NowShip/actions';

export function selectChatChannel(id) {
  return (dispatch, getState) => {
    const state = getState().chat;
    const { activeChannel } = state;
    if (activeChannel !== id) {
      dispatch({
        type: actions.SELECT_CHAT_CHANNEL,
        response: {
          id,
        },
      });
    }
  };
}

export function openChatChannel(id, isHidden = false) {
  return {
    type: actions.OPEN_CHAT_CHANNEL,
    response: {
      id,
      isHidden,
    },
  };
}

export function closeChatChannel(id) {
  return {
    type: actions.CLOSE_CHAT_CHANNEL,
    response: {
      id,
    },
  };
}

export function minifyChatChannel(id) {
  return {
    type: actions.MINIFY_CHAT_CHANNEL,
    response: {
      id,
    },
  };
}

export function focusChatChannelInput(id) {
  return {
    type: actions.FOCUS_CHAT_CHANNEL_INPUT,
    response: {
      id,
    },
  };
}

export function blurChatChannelInput(id) {
  return {
    type: actions.BLUR_CHAT_CHANNEL_INPUT,
    response: {
      id,
    },
  };
}

export function changeDraftMessage(id, tab, message) {
  return {
    type: actions.CHANGE_DRAFT_MESSAGE,
    response: {
      id,
      tab,
      message,
    },
  };
}

export function clearDraftMessage(id, tab) {
  return changeDraftMessage(id, tab, '');
}

export function selectChatTab(id, tab) {
  return {
    type: actions.SELECT_CHAT_TAB,
    response: {
      id,
      tab,
    },
  };
}

export function startLoadingMessages(id, tab) {
  return {
    type: actions.START_LOADING_MESSAGE,
    response: {
      id,
      tab,
    },
  };
}

export function stopLoadingMessages(id, tab) {
  return {
    type: actions.STOP_LOADING_MESSAGE,
    response: {
      id,
      tab,
    },
  };
}

export function updateUserSeenStatus(id, tab, userRole, lastMessageId) {
  return (dispatch, getState) => {
    const state = getState().chat;
    const { messages, userSeenStatus } = state.chatChannelData[id].chatTabData[
      tab
    ];
    const currentLastMessageId = userSeenStatus[userRole].lastMessageId;
    const currentLastMessage = messages.find(
      messageItem =>
        messageItem.id === currentLastMessageId ||
        messageItem.clientMessageId === currentLastMessageId,
    );
    const lastMessage = messages.find(
      messageItem =>
        messageItem.id === lastMessageId ||
        messageItem.clientMessageId === lastMessageId,
    );
    let resultLastMessageId = lastMessageId;
    if (currentLastMessage && lastMessage) {
      const [resultMessage] = reverse(
        sortBy([currentLastMessage, lastMessage], item =>
          parseDateTime(item.sendTime),
        ),
      );
      resultLastMessageId = resultMessage.id || resultMessage.clientMessageId;
    }
    if (resultLastMessageId !== currentLastMessageId) {
      dispatch({
        type: actions.UPDATE_USER_SEEN_STATUS,
        response: {
          id,
          tab,
          userRole,
          lastMessageId: resultLastMessageId,
        },
      });
    }
  };
}

export function addNewMessage(id, tab, { message, isNewMessage }) {
  return {
    type: actions.RECEIVE_NEW_MESSAGE,
    response: {
      id,
      tab,
      message,
      isNewMessage,
    },
  };
}

export function sendMessageSuccess(
  id,
  tab,
  { id: messageId, clientMessageId },
) {
  return {
    type: actions.SEND_MESSAGE_SUCCESS,
    response: {
      id,
      tab,
      messageId,
      clientMessageId,
    },
  };
}

export function sendMessageFail(id, tab, { clientMessageId }) {
  return {
    type: actions.SEND_MESSAGE_FAIL,
    response: {
      id,
      tab,
      clientMessageId,
    },
  };
}

export function deleteMessage(id, tab, messageId) {
  return {
    type: actions.DELETE_MESSAGE,
    response: {
      id,
      tab,
      messageId,
    },
  };
}

export function editMessage(id, tab, messageId, newMessage) {
  return {
    type: actions.EDIT_MESSAGE,
    response: {
      id,
      tab,
      messageId,
      newMessage,
    },
  };
}

// return {
//   messages,
//   hasMore,
//   userSeenStatus,
//   hasUnreadMessage,
// }
async function getMessageListAPI(appType, { id, fromMessageId }) {
  const isLoadMore = !!fromMessageId;

  async function getMessageListNowShip() {
    const getMessageBody = {
      booking_code: id,
      count: COMMON_CONST.PageSize,
      from_item_id: fromMessageId,
    };
    const response = await request.getNowShip(
      '/api/chat/get_messages',
      getMessageBody,
    );
    if (isSuccess(response)) {
      const { messages, users_seen_status: userSeenStatus } = response.reply;
      const parsedMessages = parseMessageListNowShip(messages);
      const lastMessage = parsedMessages[parsedMessages.length - 1] || {};
      const parsedUserSeenStatus = parseUserSeenStatusListNowShip(
        userSeenStatus,
      );
      const userSeenMessage =
        parsedUserSeenStatus[EnumUserChatRole.USER.id] || {};
      return {
        messages: parsedMessages,
        userSeenStatus: parsedUserSeenStatus,
        hasUnreadMessage: !isLoadMore
          ? userSeenMessage.lastMessageId !== lastMessage.id
          : null,
        hasMore: COMMON_CONST.PageSize === messages.length,
      };
    }
    throw response.result;
  }

  switch (appType) {
    case EnumChatAppType.NOW_SHIP.id: {
      return getMessageListNowShip();
    }
    default:
      return null;
  }
}

export function getMessageList(appType, id, tab, fromMessageId = undefined) {
  return async (dispatch, getState) => {
    dispatch(startLoadingMessages(id, tab));
    try {
      const response = await getMessageListAPI(
        appType,
        {
          id,
          tab,
          fromMessageId,
        },
        getState,
      );
      const {
        messages, hasMore, userSeenStatus, hasUnreadMessage,
      } = response;
      dispatch({
        type: actions.RECEIVE_MESSAGE_LIST,
        response: {
          id,
          tab,
          messages,
          userSeenStatus,
          hasUnreadMessage,
          hasMore,
        },
      });
    } catch (error) {
      dispatch(setGeneralError(trans(error)));
    }
    dispatch(stopLoadingMessages(id, tab));
  };
}

// return {
//   userSeenStatus
// }
async function markSeenMessageAPI(appType, { id, tab, messageId }, getState) {
  async function markSeenMessageNowShip() {
    const state = getState().chat;
    const { messages, userSeenStatus } = state.chatChannelData[id].chatTabData[
      tab
    ];
    const lastMessage = messages[messages.length - 1];
    const messageMarkSeenId = messageId || lastMessage.id;
    const body = {
      booking_code: id,
      message_id: messageMarkSeenId,
    };
    const response = await request.postNowShip(
      '/api/chat/mark_seen_message',
      body,
    );
    if (isSuccess(response)) {
      return {
        userSeenStatus: {
          ...userSeenStatus,
          [EnumUserChatRole.USER.id]: {
            ...userSeenStatus[EnumUserChatRole.USER.id],
            lastMessageId: messageMarkSeenId,
          },
        },
      };
    }
    throw response.result;
  }

  switch (appType) {
    case EnumChatAppType.NOW_SHIP.id: {
      return markSeenMessageNowShip();
    }
    default:
      return null;
  }
}

export function clearUnreadMessage(
  appType,
  id,
  tab,
  messageId,
  forceMarkSeenMessage = false,
) {
  return async (dispatch, getState) => {
    const state = getState().chat;
    const { hasUnreadMessage } = state.chatChannelData[id].chatTabData[tab];
    if (forceMarkSeenMessage || hasUnreadMessage) {
      for (let i = 0; i < MAX_RETRY_ATTEMPT; i += 1) {
        try {
          const response = await markSeenMessageAPI(
            appType,
            { id, tab, messageId },
            getState,
          );
          const { userSeenStatus } = response;
          dispatch({
            type: actions.CLEAR_UNREAD_MESSAGE,
            response: {
              id,
              tab,
              userSeenStatus,
            },
          });
          break;
        } catch (error) {
          console.error(
            `Retry mark seen message at attempt: ${i} - Error: ${error}`,
          );
          await wait(SLEEP_TIMEOUT);
        }
      }
    }
  };
}

// return messageId if send msg success
async function sendMessageAPI(
  appType,
  {
    id,
    // eslint-disable-next-line no-unused-vars
    tab,
    message,
    clientMessageId,
  },
) {
  async function sendMessageNowShip() {
    const body = {
      booking_code: id,
      message,
      client_message_id: clientMessageId,
    };
    const response = await request.postNowShip('/api/chat/send_message', body);
    if (isSuccess(response)) {
      const { message_id: messageId } = response.reply;
      return {
        messageId,
      };
    }
    throw response.result;
  }

  switch (appType) {
    case EnumChatAppType.NOW_SHIP.id: {
      return sendMessageNowShip();
    }
    default:
      return null;
  }
}

export function sendMessage(appType, id, tab, sentMessage) {
  function createSendMessage(message, clientMessageId, user) {
    return {
      sendTime: formatDateTime(Date.now()),
      message,
      sender: {
        id: user.uid,
        name: user.name,
        userRole: EnumUserChatRole.USER.id,
      },
      clientMessageId,
    };
  }

  return async (dispatch, getState) => {
    const { chat, auth } = getState();
    const { user } = auth;
    const { draftMessage } = chat.chatChannelData[id].chatTabData[tab];
    const message = sentMessage || draftMessage;
    if (message.length > 0) {
      if (message.length > CHAT_MESSAGE_MAX_LENGTH) {
        dispatch(setGeneralError(trans('common_chat_msg_is_too_long')));
      } else {
        dispatch(clearDraftMessage(id, tab));

        const clientMessageId = Date.now();
        const sendMessageData = createSendMessage(
          message,
          clientMessageId,
          user,
        );
        dispatch(
          updateUserSeenStatus(
            id,
            tab,
            EnumUserChatRole.USER.id,
            clientMessageId,
          ),
        );
        dispatch(
          addNewMessage(id, tab, {
            message: sendMessageData,
            isNewMessage: false,
          }),
        );
        for (let i = 0; i < MAX_RETRY_ATTEMPT; i += 1) {
          try {
            const { messageId } = await sendMessageAPI(
              appType,
              {
                id,
                tab,
                message,
                clientMessageId,
              },
              getState,
            );
            if (messageId) {
              await dispatch(
                clearUnreadMessage(appType, id, tab, messageId, true),
              ).then(() => {
                dispatch(
                  sendMessageSuccess(id, tab, {
                    id: messageId,
                    clientMessageId,
                  }),
                );
              });
              // Escape function when send msg success
              return;
            }
          } catch (error) {
            console.error(
              `Retry sending message at attempt: ${i} - Error: ${error}`,
            );
            await wait(SLEEP_TIMEOUT);
          }
        }

        // Send message fail
        dispatch(sendMessageFail(id, tab, { clientMessageId }));
      }
    }
  };
}

export function initializeChatChannel(
  appType,
  id,
  isDisabled = false,
  isReceivePush = false,
) {
  return async (dispatch, getState) => {
    const state = getState();
    if (appType === EnumChatAppType.NOW_SHIP.id) {
      if (isEmptyObject(state.ship.general.metadata)) {
        await dispatch(getMetadataNowShip(false));
      }
    }
    dispatch({
      type: actions.INIT_CHAT_CHANNEL,
      response: {
        appType,
        id,
        isDisabled,
      },
    });
    dispatch(openChatChannel(id, true));

    if (!isReceivePush) {
      dispatch(selectChatChannel(id));
    }
    const chatAppTypeEnum = findEnumById(EnumChatAppType, appType);
    const getMessageRequestList = chatAppTypeEnum.listChatTab.map(tab =>
      dispatch(getMessageList(appType, id, tab.id)),
    );

    return Promise.all(getMessageRequestList);
  };
}

export function receiveNewMessage(appType, message) {
  return async (dispatch, getState) => {
    const state = getState();
    const { chat } = state;
    const { chatChannelData } = chat;

    async function receiveNewMessageNowShip() {
      const { type, booking_code: id } = message;
      const tab = EnumChatTabTypeNowShip.SHIPPER_MERCHANT_CC.id;
      switch (type) {
        case EnumMqttChatPayloadTypeNowShip.NEW_MESSAGE.id: {
          const requestList = [];
          const { body: chatMessage } = message.message.data;
          const parsedMessage = parseMessageNowShip(JSON.parse(chatMessage));
          const {
            id: messageId,
            message: messageContent,
            clientMessageId,
            sender: { name: senderName },
          } = parsedMessage;
          const isChatChannelInit = !isEmptyObject(chatChannelData[id]);
          const isSelfSentMessage = !!clientMessageId;
          const sendNotifyNewChat = () => {
            if (!isSelfSentMessage) {
              sendNotify({
                message: `${trans('nex_now_ship_order')} #${id}`,
                detail: `${senderName} ${trans(
                  'nex_wrote',
                )}: ${messageContent}`,
              });
            }
          };
          if (!isChatChannelInit) {
            requestList.push(
              dispatch(initializeChatChannel(appType, id, false, true)).then(
                () => {
                  sendNotifyNewChat();
                },
              ),
            );
          } else {
            // clear unread message if chat box is open (same id and tab type)
            // and chat text input is focused
            const { activeChannel } = chat;
            const {
              currentChatTab,
              isChatTextFocus,
              chatTabData,
            } = chatChannelData[id];
            const { messages } = chatTabData[tab];
            // do not handle more for message sent from current tab browser
            if (
              clientMessageId &&
              messages.find(
                messageItem => messageItem.clientMessageId === clientMessageId,
              )
            ) {
              break;
            }
            const isReadMessage =
              activeChannel === id && currentChatTab === tab && isChatTextFocus;
            const dispatchReceiveNewMessage = () => {
              dispatch(
                addNewMessage(id, tab, {
                  message: parsedMessage,
                  isNewMessage: !isSelfSentMessage && !isReadMessage,
                }),
              );
            };

            if (isSelfSentMessage) {
              dispatch(
                updateUserSeenStatus(
                  id,
                  tab,
                  EnumUserChatRole.USER.id,
                  clientMessageId,
                ),
              );
              dispatchReceiveNewMessage();
            } else if (isReadMessage) {
              requestList.push(
                dispatch(clearUnreadMessage(appType, id, tab, messageId)).then(
                  dispatchReceiveNewMessage,
                ),
              );
            } else {
              dispatchReceiveNewMessage();
              sendNotifyNewChat();
            }
          }

          break;
        }
        case EnumMqttChatPayloadTypeNowShip.UPDATE_USER_SEEN_STATUS.id: {
          const { body: rawUserSeenStatus } = message.message.data;
          const userSeenStatus = JSON.parse(rawUserSeenStatus);
          const {
            last_message_id: lastMessageId,
            user_role: userRole,
          } = userSeenStatus;
          dispatch(updateUserSeenStatus(id, tab, userRole, lastMessageId));

          break;
        }
        case EnumMqttChatPayloadTypeNowShip.DELETE_MESSAGE.id: {
          const { body: rawDeleteMessage } = message.message.data;
          const deleteMessageBody = JSON.parse(rawDeleteMessage);
          dispatch(deleteMessage(id, tab, deleteMessageBody.id));

          break;
        }
        case EnumMqttChatPayloadTypeNowShip.EDIT_MESSAGE.id: {
          const { body: rawEditMessage } = message.message.data;
          const editMessageBody = JSON.parse(rawEditMessage);
          const { id: messageId, message: newMessage } = editMessageBody;
          dispatch(editMessage(id, tab, messageId, newMessage));

          break;
        }
        default:
      }
    }

    switch (appType) {
      case EnumChatAppType.NOW_SHIP.id: {
        return receiveNewMessageNowShip();
      }
      default:
        return null;
    }
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/ChatBox/actions.js